import { z } from 'zod';

export const RetentionMessage = z.object({
  messageIdentifier: z.string(),
});
export type RetentionMessage = z.infer<typeof RetentionMessage>;

export const AlternateProductMessage = z.object({
  messageIdentifier: z.string(),
  productId: z.string(),
});
export type AlternateProductMessage = z.infer<typeof AlternateProductMessage>;

export const PromotionalOfferSignatureV1 = z.object({
  encodedSignature: z.string(),
  productId: z.string(),
  nonce: z.string(), // lowercase uuid
  timestamp: z.number().int().positive(),
  keyId: z.string(),
  offerIdentifier: z.string(),
  appAccountToken: z.string().optional(),
});
export type PromotionalOfferSignatureV1 = z.infer<typeof PromotionalOfferSignatureV1>;

export const PromotionalOfferSignatureV2 = z.string();
export type PromotionalOfferSignatureV2 = z.infer<typeof PromotionalOfferSignatureV2>;

// promotionalOfferSignature V1 and V2 are mutually exclusive
// https://developer.apple.com/documentation/retentionmessaging/promotionaloffer
export const PromotionalOfferMessage = z.union([
  z.object({
    messageIdentifier: z.string(),
    promotionalOfferSignatureV1: PromotionalOfferSignatureV1,
    promotionalOfferSignatureV2: z.never().optional(),
  }),
  z.object({
    messageIdentifier: z.string(),
    promotionalOfferSignatureV1: z.never().optional(),
    promotionalOfferSignatureV2: PromotionalOfferSignatureV2,
  }),
]);
export type PromotionalOfferMessage = z.infer<typeof PromotionalOfferMessage>;

// these message types are all mutually exclusive
// https://developer.apple.com/documentation/retentionmessaging/realtimeresponsebody
export const GetRetentionMessageResponse = z.union([
  z.object({
    message: RetentionMessage,
    alternateProduct: z.never().optional(),
    promotionalOffer: z.never().optional(),
  }),
  z.object({
    message: z.never().optional(),
    alternateProduct: AlternateProductMessage,
    promotionalOffer: z.never().optional(),
  }),
  z.object({
    message: z.never().optional(),
    alternateProduct: z.never().optional(),
    promotionalOffer: PromotionalOfferMessage,
  }),
]);
export type GetRetentionMessageResponse = z.infer<typeof GetRetentionMessageResponse>;
